import React from "react";
import { IconButton } from "@/shared/ui/IconButton";
import { useShareProfile } from "@/features/people/hooks/useShareProfile";
import { FeatureGate } from "@/shared/widgets/FeatureFlags";
import { useTranslation } from "react-i18next";
import { FeatureFlagKey } from "@/types/feature-flags";

interface ShareCandidateTriggerProps {
  personId: number;
  projectId: number;
  orgId: number;
}

const ShareCandidateTrigger = ({
  personId,
  projectId,
  orgId,
}: ShareCandidateTriggerProps) => {
  const { t } = useTranslation();
  const { handleShareProfile, loading } = useShareProfile();

  return (
    <FeatureGate flagKey={FeatureFlagKey.PUBLIC_SHAREABLE_PROFILE}>
      <IconButton
        icon="Link"
        label={t("profile.share_candidate")}
        variant="outline"
        loading={loading}
        color="darkGrey"
        onClick={() => handleShareProfile({ personId, projectId, orgId })}
      />
    </FeatureGate>
  );
};

export default ShareCandidateTrigger;
